module.exports = require("@wel-ui/component-link");



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/Link/index.js
// module id = 371
// module chunks = 0